import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { defaultFieldValues } from 'components/dashboard/signup-generator-content/SignupGeneratorAppearence/fieldDecorator';
import previewTermsDecorator from 'components/dashboard/signup-generator-content/SignupGeneratorAppearence/previewTermsDecorator';

import SignupGeneratorField from 'components/dashboard/signup-generator-content/SignupGeneratorField';
// import SignupGeneratorAppearenceDropdown from 'components/dashboard/signup-generator-content/SignupGeneratorAppearenceDropdown';

import './SignupGeneratorAppearence.css';

// const dropdownOptions = [
//   { key: 'appearence_dropdown_position_bottom', text: 'Bottom Position', value: 'bottom' },
//   { key: 'appearence_dropdown_position_top', text: 'Top Position', value: 'top' },
// ];

const SignupGeneratorAppearence = ({ signupGenerator }) => {
  const { t } = useTranslation();
  const [buttonText, setButtonText] = useState(signupGenerator.button_text || null);
  const [successText, setSuccessText] = useState(signupGenerator.success_text || null);
  // const [buttonPosition, setButtonPosition] = useState(signupGenerator.position || null);

  return (
    <div className="email-signup-generator-appearence__component">
      <div className="email-signup-generator-appearence-wrapper">
        <h4>{t("Button Text & Success Message")}</h4>

        <div className="email-signup-generator-appearence-content">
          <SignupGeneratorField
            value={buttonText}
            onChange={(e) => {
              e.preventDefault();
              setButtonText(e.target.value);
            }}
            placeholder={defaultFieldValues.button_text}
            fieldLabel={t("Button Text")}
            name="button_text"
            required
          />

          <SignupGeneratorField
            value={successText}
            onChange={(e) => {
              e.preventDefault();
              setSuccessText(e.target.value);
            }}
            placeholder={defaultFieldValues.success_text}
            fieldLabel={t("Success Message")}
            name="success_text"
            required
          />

          {/* <SignupGeneratorAppearenceDropdown
            value={buttonPosition}
            onChange={(_e, { value }) => { setButtonPosition(value); }}
            placeholder="Bottom Position"
            options={dropdownOptions}
            name="position"
            noClickOutside
          /> */}
        </div>
      </div>
    </div>
  );
};

SignupGeneratorAppearence.propTypes = {
  signupGenerator: PropTypes.object,
};

SignupGeneratorAppearence.defaultProps = {
  signupGenerator: null,
};

export default previewTermsDecorator(SignupGeneratorAppearence);
